import type { ModulesAndAgendasState } from '../index';
import type { LocalFormItem } from 'types/agendaForm.ts';
import { findSectionIndex, findTabIndex } from 'utils/section/tabSection.ts';
import { recalcSectionItems } from 'utils/section/items.ts';
import { getStartPos } from 'utils/section/gridUtils';

interface Payload {
  name: string;
  position: { x: number; y: number };
  currentTab: number;
  currentSubTab: number;
}

export const removeSectionItem = (state: ModulesAndAgendasState, { payload }: { payload: Payload }) => {
  const { name, position, currentTab, currentSubTab } = payload;
  const tabSections = state.tabSections;

  const currentTabIndex = findTabIndex(tabSections, currentTab);

  if (currentTabIndex === -1) throw new Error('Invalid tab index');

  const sectionIndex = findSectionIndex(tabSections[currentTabIndex].sections, name);
  if (sectionIndex === -1) throw new Error('Invalid section index');

  const section = tabSections[currentTab].sections[sectionIndex];

  const currentSubTabIndex = findTabIndex(section.formItemTabs, currentSubTab);
  const formItemTabs = section.formItemTabs[currentSubTabIndex];
  section.formItemTabs[currentSubTabIndex].items = removeItem(formItemTabs.items, position);

  section.items = recalcSectionItems(section.formItemTabs);
};

const removeItem = (items: LocalFormItem[], position: { x: number; y: number }): LocalFormItem[] => {
  return items.map((item) => {
    const itemX = getStartPos(item.x);
    const itemY = getStartPos(item.y);

    if (itemX === position.x && itemY === position.y) {
      return {
        x: String(itemX),
        y: String(itemY),
        identifier: item.identifier,
        data: null,
        isEmpty: true,
      };
    }
    return item;
  });
};
